import { useAppDispatch, useAppSelector } from "hooks";
import { Fragment, useCallback, useEffect, useState } from "react";
import { selectPoisBountyV3State, setOpen } from "redux/slices";
import { useLocation, useNavigate } from "react-router-dom";
import { useWebStoreContext } from "contexts/WebStoreProvider";
import { useLinks } from "hooks/useLinks";

type Links =
	| "/pois-bounty"
	| "/club-shop"
	| "/club-free-gift"
	| "/special-offers";

const LS_SURVIVABLE_LINK = "store.solitairetripeaks.com:survivableLink";
const LS_PREVENT_SURVIVABLE =
	"store.solitairetripeaks.com:preventSurvivableLink";

interface UnLoggedRedirectionProps {}

export const UnLoggedRedirection: React.FC<UnLoggedRedirectionProps> = ({
	children
}) => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { pathname } = useLocation();
	const [appStarted, setAppStarted] = useState<boolean>(false);
	const { eventActive } = useAppSelector(selectPoisBountyV3State);
	const { userTracker, openLoginToContinueDialog } = useWebStoreContext();
	const path = localStorage.getItem(LS_SURVIVABLE_LINK) as Links;
	const links = useLinks();
	const SURVIVABLE_LINKS = [
		links.pois_bounty.path,
		links.club_shop.path,
		links.club_free_gift.path,
		links.drip_offer.path
	];

	const cleanAfterNavigate = useCallback(() => {
		dispatch(setOpen(false));
		localStorage.removeItem(LS_SURVIVABLE_LINK);
		localStorage.setItem(LS_PREVENT_SURVIVABLE, "prevent");
	}, []);

	useEffect(() => {
		if (!SURVIVABLE_LINKS.includes(pathname)) {
			localStorage.removeItem(LS_PREVENT_SURVIVABLE);
		}
	}, [pathname]);

	useEffect(() => {
		if (!userTracker && SURVIVABLE_LINKS.includes(pathname) && !appStarted) {
			const prevent = localStorage.getItem(LS_PREVENT_SURVIVABLE);
			if (prevent) {
				return;
			}
			openLoginToContinueDialog();
			localStorage.setItem(LS_SURVIVABLE_LINK, pathname);
			setAppStarted(true);
		}
	}, [userTracker, appStarted]);

	useEffect(() => {
		if (!userTracker) {
			return;
		}
		const { clubId } = userTracker;

		if (path === "/pois-bounty" && eventActive) {
			navigate("/pois-bounty");
			cleanAfterNavigate();
		}

		if (path === "/club-shop" && clubId) {
			navigate("/club-shop");
			cleanAfterNavigate();
		}

		if (path === "/club-free-gift" && clubId) {
			navigate("/club-free-gift");
			cleanAfterNavigate();
		}

		if (path === "/special-offers") {
			navigate("/special-offers");
			cleanAfterNavigate();
		}
	}, [userTracker, eventActive, path]);

	return <Fragment>{children}</Fragment>;
};
